export const GET_GEODATA_REQUEST = "GET_GEODATA_REQUEST";
export const GET_GEODATA_SUCCESS = "GET_GEODATA_SUCCESS";
export const GET_GEODATA_FAIL = "GET_GEODATA_FAIL";
export const GET_GEODATA_RESET = "GET_GEODATA_RESET";
